module.exports = __webpack_public_path__ + "static/media/treatment2.aca6001a.png";